// Unpublished Work © 2026 Deere & Company.

export const redirect = (url: string) => {
    window.location.assign(url);
};
